@import '../../../constants/spacing.module.less';
@import '../../../constants/screen-width-breakpoints.module.less';

.home-page {
  margin-top: @space-0;
  padding: @space-0;
  gap: @space-0;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background-color: var(--Surface-Default);

  .content {
    margin-top: @space-40;
    gap: @space-40;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: @space-0 @space-24 40px;
  }
}

.migration-banner {
  max-width: 1000px;
  width: 100%;
}

.set-up-banner-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  container-type: inline-size;
}

@media @mobile {
  .home-page {
    .content {
      margin-top: @space-16;
      gap: @space-40;
      padding: @space-0 @space-0 @space-40;
    }
  }
}

@media @tablet {
  .home-page {
    .content {
      margin-top: @space-24;
      gap: 60px;
      padding: @space-0 @space-24 @space-40;
    }
  }
}
